<template>
  <main
    class="my-team"
    v-if="$store.state.user.loggedIn"
  >
    <!-- Add margin for Desktop -->
    <div class="desktop-bumper" />

    <!-- If Completed Race that we didn't participate in -->
    <template v-if="race && !raceHasTeam">
      <ims-item class="py-3 mb-3 ims-item-last border-top">
        <h1 style="text-align: center;">No Team Selected for this Race</h1>
      </ims-item>
    </template>

    <!-- Score if Completed -->
    <section
      class="team-score"
      v-if="
        raceHasTeam &&
          race.status !== $AppConfig.status.PRE_RACE
      "
    >
      <div class="container-sm pt-3">
        <div class="ims-row">
          <span class="filler">
            <h1 class="text-lg text-bold">{{ team.teamName }}</h1>
            <p class="text-sm">{{ race.name }}</p>
          </span>
          <span class="text-right">
            <h1 class="text-lg text-bold">{{ team.totalPoints }}</h1>
            <p class="text-sm">points</p>
          </span>
        </div>
      </div>
    </section>

    <!-- Driver Selector For this Race -->
    <section
      class="driver-selector bg-white pt-3 border-top"
      v-if="race && raceHasTeam"
    >
      <div class="driver-slots">
        <!-- Show Pickable Race -->
        <div
          class="driver-ball-slot"
          v-for="(driver, index) in positionPicks"
          :key="index"
        >
          <ims-driver-ball
            :label="ballLabel(driver, `#${index + 1}`)"
            :size="ballSize"
            :showCoin="raceLive || raceComplete"
            :driver="driver"
          />
        </div>
      </div>
    </section>
    <!-- If Picks Closed - but they have a team -- show the balls -->
    <section
      class="driver-selector bg-white pt-3 border-top"
      v-else-if="racePicksClosed && raceHasTeam"
    >
      <div class="driver-slots">
        <!-- Show Pickable Race -->
        <div
          class="driver-ball-slot"
          v-for="(driver, index) in positionPicks"
          :key="index"
        >
          <ims-driver-ball
            :label="ballLabel(driver, `#${index + 1}`)"
            :size="ballSize"
            :showCoin="racePicksClosed"
            :driver="driver"
            v-if="driver"
            :key="index"
          />
        </div>
      </div>
    </section>
    <!-- End Driver Selector -->

    <!-- Start Pick the Podium-->
    <ims-item
      class="divider"
      v-if="race && (raceHasTeam || !racePicksClosed)"
    >
     <template v-if="race.totalLaps > 4">
      Pick the Podium
      </template>
      <template v-else>
        Pick the Front Row
      </template>
      <template v-slot:right>
        <span class="text-sm">Bonus Points</span>
      </template>
    </ims-item>

    <section
      class="pick-podium bg-white"
      v-if="race && (raceHasTeam || !racePicksClosed)"
    >
      <div
        class="item-wrapper"
        v-for="(driver, index) in selectedPodium"
        :key="index"
      >
        <!-- Driver is selected -->
        <ims-item
          v-if="driver"
          class="py-1"
          :class="index == selectedPodium.length - 1 ? 'ims-item-last' : ''"
        >
          <template v-slot:left>
            <ims-avatar
              size="md"
              :src="driver.getAvatar()"
            />
          </template>
          <h1>#{{ index + 1 }} {{ driver.firstName }} {{ driver.lastName }}</h1>
          <template v-slot:right>
            <ims-coin
              v-if="raceComplete"
              :value="driver.finishPoints"
              v-bind:size="[15 > 100 ? 'lg' : 'md']"
              class="mr-2"
            />
            <span
              v-if="raceComplete"
              class="text-primary text-bold text-lg podium-position"
            >{{ (index + 1) | ordinal }}</span>
            <ims-icon
              icon="close"
              color="primary"
              v-if="!racePicksClosed"
            />
          </template>
        </ims-item>
        <!-- Nothing selected for this slot -->
        <ims-item v-else
                  class="py-1"
                  :class="index == selectedPodium.length - 1 ? 'ims-item-last' : ''">
            <template v-slot:left>
                <ims-avatar size="md">
                    <ims-icon icon="add"
                              size="lg"
                              v-if="!raceComplete" />
                    <ims-icon icon="person"
                              size="lg"
                              v-if="raceComplete" />
                </ims-avatar>
            </template>
            <template v-if="race.totalLaps > 4">
                <h1 v-if="!raceComplete">Pick {{ (index + 1) | ordinal }} Place</h1>
                <h1 v-else>No {{ (index + 1) | ordinal }} Place Picked</h1>
            </template>
            <template v-else>
                <h1 v-if="!raceComplete && (index + 1) === 1">Pick Pole Position</h1>
                <h1 v-else-if="!raceComplete && (index + 1) === 2">Pick Middle - Row 1</h1>
                <h1 v-else-if="!raceComplete && (index + 1) === 3">Pick Outside - Row 1</h1>
                <h1 v-else>No Pick Made</h1>
            </template>
        </ims-item>
      </div>
    </section>
    <!-- End Pick the Podium -->

    <!-- Start Tie Breaker -->

    <section
      class="tie-breaker"
      v-if="racePicksOpen || raceHasTeam"
    >
      <ims-item class="divider">
        Tie Breaker
          <template v-slot:right>
              <span class="text-sm" v-if="race.totalLaps > 4">Fastest Race Lap</span>
              <span class="text-sm" v-else>Pole Position Four-Lap Average</span>
          </template>
      </ims-item>
      <div class="bg-white p-2 pt-3 border-bottom">
        <!-- Fastest Lap Input -->
        <ims-item class="container-xs no-border mb-1">
          <label class=" text-sm mb-0 " v-if="race.totalLaps > 4">Your Fastest Lap Guess</label>
          <label class=" text-sm mb-0 " v-else>Your Pole Position Four-Lap Average Guess</label>
              
          <ims-input
            class="text-xl mb-0"
            type="number"
            v-model="team.tieBreaker"
            :disabled="racePicksClosed"
          >
            <template v-slot:right>
              <span class="text-blue text-bold text-lg">MPH</span>
            </template>
          </ims-input>
        </ims-item>

        <!-- Actual Fastest Lap -->
        <ims-item
          class="container-xs no-border"
          v-if="raceComplete"
        >
          <label class="mb-0 mt-2 text-sm " v-if="race.totalLaps > 4">Actual Fastest Lap</label>
          <label class="mb-0 mt-2 text-sm " v-else>Actual Pole Position Four-Lap Average</label>
          <ims-input
            class="text-xl"
            type="number"
            :disabled="true"
            v-model="race.fastRaceLapSpeed"
          >
            <template v-slot:right>
              <span class="text-blue text-bold text-lg">MPH</span>
            </template>
          </ims-input>
        </ims-item>
      </div>
      <!-- Warn if they guess too high -->
      <div class="container-xs p-3">
        <div class="text-sm text-center text-faded-dark">
          Guess:
          <strong class="text-dark">{{ tieBreakerFormated }} mph</strong>
        </div>
        <p class="text-center text-sm text-faded-dark my-3">
          In the event of a tie,
          <br />the most accurate fastest lap will win.
        </p>
      </div>
    </section>

    <!-- End buffer padding -->
  </main>
</template>

<script>
import Driver from '@/classes/driver';
import LeagueTeam from '@/classes/leagueTeam';
import Race from '@/classes/race';
import tick from '../../modules/tick/tick';

export default {
  components: {},
  props: {
    team: {
      type: LeagueTeam,
      default() {
        return null;
      },
    },
    race: {
      type: Race,
      default() {
        return null;
      },
    },
  },
  data() {
    return {};
  },
  /**
   * Computed Variables
   * eg. this.team this.race
   */
  computed: {
    // Get Team object - from the Race object
    /* team() {
      return this.race.team;
    },
    // Get the Race Object from the Store
    race() {
      return this.$store.state.races.race;
    }, */
    // Are the Picks Closed - default to true
    racePicksClosed() {
      if (this.race) {
        return this.race.picksClosed();
      } else {
        return true;
      }
    },
    // Are the Picks Open
    racePicksOpen() {
      return !this.racePicksClosed;
    },
    // Does this Race have a Valid Team?
    raceHasTeam() {
      return this.race && this.team.id && this.team.pick1;
    },
    // Is the Race Complete?
    raceComplete() {
      return this.race && this.race.status == this.$AppConfig.status.COMPLETE;
    },
    // Is the Race Live?
    raceLive() {
      return (
        this.race && this.race.status == this.$AppConfig.status.IN_PROGRESS
      );
    },
    // What Driver Ball Size should we use?
    ballSize() {
      if (this.race.pickCount === 8) {
        return 'md';
      } else {
        return 'lg';
      }
    },
    // Get the Team Name if one exists - otherwise use My Team
    teamName() {
      //if (this.$store.getters['user'].profile) {
      //  return this.$store.getters['user'].profile.teamName;
      //} else {
        return 'My Team';
      //}
    },
    // Get the Position picks as an array
    positionPicks() {
      let drivers = [];
      // Loop over number of picks allowed by race
      if (this.race) {
        for (var i = 0; i < this.race.pickCount; i++) {
          // If team has PicksIndex+1
          if (this.team[`pick${i + 1}`]) {
            // Find driver and push to drivers
            drivers.push(this.driverById(this.team[`pick${i + 1}`]));
          } else {
            drivers.push(null);
          }
        }
      }
      return drivers;
    },
    /** Get Current Budget Used */
    budget() {
      let amount = 0;
      this.positionPicks.forEach(driver => {
        if (driver) {
          amount = amount + driver.value;
        }
      });
      return amount;
    },
    /** Format Tie Breaker */
    tieBreakerFormated() {
      return parseFloat(this.team.tieBreaker || 0).toFixed(3);
    },
    /** Get Selected Podium Drivers */
    selectedPodium() {
      let drivers = [null, null, null];
      let points = this.team.getFinishPoints() || [0, 0, 0];
      // Loop over empty array 3 times
      let selected = drivers.map((driver, i) => {
        // If driver exists in team.Finished1 then use it
        let driverId = this.team[`finish${i + 1}`];
        if (driverId) {
          let driver = this.driverById(driverId);
          if (driver) {
            driver.finishPoints = points[i] || 0;
          }
          return driver;
        } else {
          return null;
        }
      });
      return selected;
    }
  },
  methods: {
    // Initialize the Component
    async init() {
      let closeLoader = await this.$store.dispatch(
        'loader/start',
        'Getting Team Information...'
      );
      // If no races or race - load the races
      if (
        !this.$store.state.races.races.length ||
        !this.$store.state.races.race
      ) {
        await this.$store.dispatch('races/load', 'league-team init');
      }
      closeLoader();
    },
    ballLabel(driver, position) {
      if (driver) {
        return `${driver.firstName}<br/>${driver.lastName}`;
      } else {
        return `No Selected<br/>Driver ${position}`;
      }
    },
    /** Fire off that Team Changed */
    fireChange() {
      // Adjusting tieBreaker since the API throws an error for anything over 999 :|
      if (this.team.tieBreaker > 999) {
        this.team.tieBreaker = 400;
      }
      this.$emit('change', this.team);
    },
    /** Get a Driver By ID */
    driverById(id) {
      if (this.race){
        return this.race.drivers.find(driver => {
          return driver.raceDriverId == id;
        });
      }else{
        return null;
      }
    },
    speedCheck(speed) {
      return speed > this.$AppConfig.maxLapSpeed;
    },
    noPicks(picks) {
      return picks.every(item => item == null);
    },
    remainingBudget(current, total) {
      return parseInt(total) - parseInt(current);
    }
  },
  /**
   * Watcher
   * Watch for changes on a variable
   */
  watch: {
    // When user is logged in.
    '$store.state.user.loggedIn': {
      async handler(isLoggedIn) {
        if (isLoggedIn) {
          this.init();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';
@import '../../scss/vendors/bootstrap-utils';

.my-team {
  $sm-mw: 480px;
  .tie-breaker {
    margin-bottom: 20px;
  }
  .ims-meter {
    max-width: $sm-mw;
    width: 90vw;
    padding: 16px;
  }
  .team-score {
    background-color: #fff;
    padding: 0 16px 16px 16px;
    .ims-row {
      padding: 10px 16px;
      background-color: $yellow-fade;
      border-radius: 10px;

      h1,
      p {
        margin: 0;
        padding: 0;
      }
    }
  }
  .podium-position {
    width: 60px;
  }
}
.driver-selector {
  overflow: hidden;
  .driver-ball-slot {
  }
  .driver-slots {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  .ims-button {
    line-height: 100%;
    text-transform: none;
    font-size: 1.1rem;
    label {
      margin-top: 10px;
    }
  }
  // When you pick 8 drivers
}

// @media (max-width: 980px) and (min-width:768px) {
//   .driver-selector .driver-slots {
//     max-width: 420px;
//     margin: 0 auto;
//   }
// }

@media (max-width: 767px) {
  .driver-selector .driver-slots {
    max-width: 370px;
    margin: 0 auto;
  }
}

@media (max-width: 640px) {
  .driver-selector .driver-slots {
    max-width: 320px;
  }
}
</style>
